var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("money-text", { attrs: { amount: _vm.taxToPrint } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }